import React, {Component} from 'react';
import _ from 'lodash';
import CountryCodeStore from '../stores/CountryCodeStore';

import connectToStores from 'alt/utils/connectToStores';

@connectToStores
class PhoneFieldComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: null
        };

        CountryCodeStore.getCountryCodes()
    }

    static getPropsFromStores() {
        return {
            CountryCodeStore: CountryCodeStore.getState()
        };
    }

    static getStores() {
        return [CountryCodeStore];
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value === null && prevProps.value && this.refs.countryCode) {
            let value = prevProps.value;
            if (value && value.startsWith('+') && prevProps.CountryCodeStore.codesLoaded) {
                const countryCodeInput = this.refs.countryCode.getDOMNode();
                const countryCodes = prevProps.CountryCodeStore.countryCodes;
                const countryCode = _.find(countryCodes, (code) => {
                    return value.startsWith(code.code);
                });
                if (typeof countryCode !== 'undefined') {
                    countryCodeInput.value = countryCode.code;
                    value = value.substring(countryCode.code.length);
                } else if (value.length >= 4) {
                    countryCodeInput.value = '';
                }
            }
            this.setState({value});
        }
    }

    replaceInvalidCharacters(value) {
        value = value.startsWith('0') ? value.substring(1) : value;
        if (value.length > 1 && value.startsWith('+')) {
            value = value[0] + value.substring(1).replace(/[^0-9]+/g, '');
        } else {
            if (value.length == 1) {
                value = value.replace(/[^0-9\+]+/g, '');
            } else {
                value = value.replace(/[^0-9]+/g, '');
            }
        }
        return value
    }

    onChange(e) {
        let value = this.replaceInvalidCharacters(e.target.value);
        const countryCodes = this.props.CountryCodeStore.countryCodes;
        if (value.startsWith('+')) {

            const countryCode = _.find(countryCodes, (code) => {
                return value.startsWith(code.code);
            });

            if (typeof countryCode !== 'undefined') {
                this.refs.countryCode.getDOMNode().value = countryCode.code;
                value = '';
            } else if (value.length == 4) {
                this.refs.countryCode.getDOMNode().value = '';
            }
        }
        this.setState({value});
        const fullValue = value.startsWith('+') ? value : value.length ? this.refs.countryCode.getDOMNode().value + value : '';
        this.props.onChange(fullValue);
    }

    renderField(){
        const value = this.state.value;
        return <input className="form-control" ref="phoneInput" value={value} placeholder={this.props.label} onChange={this.onChange.bind(this)}/>
    }

    getOptions(countryCodes) {
        let options = [];
        if (Object.keys(countryCodes).length) {
            countryCodes.forEach(code => {
                options.push(
                    <option key={code.id} value={code.code} label={code.code}>{code.code}</option>
                );
            });
        }
        options.push(
            <option key={0} value="">--------</option>
        );
        return options;
    }

    changeCountryCode() {
        const inputValue = this.refs.phoneInput.getDOMNode().value;
        if (inputValue.startsWith('+') && inputValue.length >= 4) {
            this.refs.phoneInput.getDOMNode().value = inputValue.substring(4);
        }

        this.setState({inputValue});
        const fullValue = inputValue.startsWith('+') ? inputValue : inputValue.length ? this.refs.countryCode.getDOMNode().value + inputValue : '';
        this.props.onChange(fullValue);
    }

    render () {
        const countryCodes = this.props.CountryCodeStore.countryCodes;
        if (!this.props.CountryCodeStore.codesLoaded) {
            return (<div></div>);
        }
        // Number input has to be first in the label for Safari
        return (
            <div>
            <label className='form-control form-control-phone'>
                {this.renderField()}
                <div className="form-control-select">
                    <select ref="countryCode" className="country-code" name='countryCode' onChange={this.changeCountryCode.bind(this)}>
                        {this.getOptions(countryCodes)}
                    </select>
                </div>
                {this.props.error ? <span className="help-block error-block">{this.props.error}</span> : ''}
            </label>
            </div>
        );
    }
}

PhoneFieldComponent.propTypes = {
    formField: React.PropTypes.object.isRequired
};

export default PhoneFieldComponent;



/** WEBPACK FOOTER **
 ** ./app/src/components/PhoneFieldComponent.js
 **/